import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";

import modal from "../../shared/actions";

const AccessDenied = ({ closeModal }) => (
  <div className="p-card--highlighted u-no-margin--bottom">
    <h4>Access denied</h4>
    <p>
      Logged in successfully, but you do not have the necessary permission to
      access Canonical&#39;s role based access control system. Please contact
      your administrator if you believe this is incorrect.
    </p>
    <div className="l-flex-end-centered">
      <button
        type="button"
        className="u-no-margin--bottom"
        onClick={() => closeModal()}
      >
        Close
      </button>
    </div>
  </div>
);

AccessDenied.propTypes = {
  closeModal: PropTypes.func.isRequired
};

const mapDispatchToProps = {
  closeModal: modal.close
};

export default connect(
  undefined,
  mapDispatchToProps
)(AccessDenied);
